import { render } from "./SinglePayment.vue?vue&type=template&id=6cbba5dd"
import script from "./SinglePayment.vue?vue&type=script&lang=js"
export * from "./SinglePayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__